var map = {
	"./Asscher@2x.png": 318,
	"./Cushion@2x.png": 319,
	"./Emerald@2x.png": 320,
	"./Faceted Trapezoid@2x.png": 321,
	"./Half Moon@2x.png": 322,
	"./Heart@2x.png": 323,
	"./Marquise@2x.png": 324,
	"./Oval@2x.png": 325,
	"./Pear@2x.png": 326,
	"./Princess@2x.png": 327,
	"./Radiant@2x.png": 328,
	"./Round@2x.png": 329,
	"./Step Cut Trapezoid@2x.png": 330,
	"./Straight Baguette@2x.png": 331,
	"./Tapered Baguette@2x.png": 332,
	"./Triangle@2x.png": 333,
	"./Trilliant@2x.png": 334
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1387;



//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images ^\.\/.*@2x\.png$
// module id = 1387
// module chunks = 0